/* ==========================================================================
   OBLIVION STOREFRONT — Shopify runtime
   Same behaviour as the FINAL-VIEW prototype, wired to the live store:
   cart goes through Shopify's AJAX Cart API, search through /search,
   wishlist stays in localStorage (client-side only, as before).
   ========================================================================== */
(function () {
  'use strict';

  var CFG = window.OB_CONFIG || {};
  var MONEY = CFG.moneyFormat || '₹{{amount_no_decimals}}';

  /* ---------------- helpers ---------------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function el(html) { var d = document.createElement('div'); d.innerHTML = String(html).trim(); return d.firstElementChild; }
  function qs(k) { return new URLSearchParams(location.search).get(k) || ''; }

  /* Shopify money_format renderer — cents in, formatted string out */
  function money(cents) {
    if (cents == null || isNaN(cents)) return '';
    function grp(n, dec, sep, thou) {
      n = (n / 100).toFixed(dec);
      var p = n.split('.');
      var i = p[0].replace(/(\d)(?=(\d\d)+\d$)/g, '$1' + (thou || ','));
      return p[1] ? i + (sep || '.') + p[1] : i;
    }
    return MONEY.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount': return grp(cents, 2, '.', ',');
        case 'amount_no_decimals': return grp(cents, 0, '.', ',');
        case 'amount_with_comma_separator': return grp(cents, 2, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return grp(cents, 0, ',', '.');
        case 'amount_with_space_separator': return grp(cents, 2, ',', ' ');
        case 'amount_no_decimals_with_space_separator': return grp(cents, 0, ',', ' ');
        default: return grp(cents, 2, '.', ',');
      }
    });
  }

  function overlayRoot() {
    var root = document.getElementById('obOverlays');
    if (!root) {
      root = el('<div class="ob-root ob-chrome" id="obOverlays"></div>');
      document.body.appendChild(root);
    }
    return root;
  }

  /* ---------------- toast ---------------- */
  var tEl, tTimer;
  function toast(msg) {
    if (!tEl) { tEl = el('<div class="toast" role="status" aria-live="polite"></div>'); overlayRoot().appendChild(tEl); }
    tEl.textContent = msg; tEl.classList.add('on');
    clearTimeout(tTimer); tTimer = setTimeout(function () { tEl.classList.remove('on'); }, 2200);
  }

  /* ---------------- icons ---------------- */
  var I = {
    search: '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg>',
    back: '<svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>',
    cart: '<svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18M16 10a4 4 0 0 1-8 0"/></svg>',
    home: '<svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="m3 10 9-7 9 7v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z"/><path d="M9 22V12h6v10"/></svg>',
    grid: '<svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>',
    heart: '<svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linejoin="round"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1.1 1L12 21l7.7-7.6 1.1-1a5.5 5.5 0 0 0 0-7.8Z"/></svg>',
    heartSm: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linejoin="round"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1.1 1L12 21l7.7-7.6 1.1-1a5.5 5.5 0 0 0 0-7.8Z"/></svg>',
    star: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="m12 2 3.1 6.3 6.9 1-5 4.9 1.2 6.8L12 17.8 5.8 21l1.2-6.8-5-4.9 6.9-1Z"/></svg>',
    arrowR: '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 5l7 7-7 7"/></svg>',
    chevL: '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg>',
    chevR: '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg>',
    chevD: '<svg class="chev" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>',
    up: '<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="m18 15-6-6-6 6"/></svg>',
    filter: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M3 6h18M6 12h12M10 18h4"/></svg>',
    sort: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h13M3 12h9M3 18h5M17 8v11M17 19l3-3M17 19l-3-3"/></svg>',
    share: '<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m22 2-7 20-4-9-9-4Z"/></svg>',
    close: '<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.3" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>',
    pin: '<svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7Zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5Z"/></svg>'
  };

  /* ---------------- cart (Shopify AJAX API) ---------------- */
  var cartRevision = 0;
  var Cart = {
    count: 0,
    paint: function (n) {
      if (typeof n === 'number') { Cart.count = n; cartRevision++; }
      document.querySelectorAll('[data-cart-count]').forEach(function (e) {
        e.textContent = Cart.count;
        e.style.display = Cart.count ? '' : 'none';
      });
    },
    refresh: function () {
      var revision = ++cartRevision;
      return fetch(CFG.routes.cart + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { if (revision === cartRevision) Cart.paint(c.item_count); return c; })
        .catch(function () { });
    },
    add: function (id, qty) {
      return fetch(CFG.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message || 'Could not add to cart'); });
        return r.json();
      }).then(function (res) {
        return Cart.refresh().then(function () {
          document.dispatchEvent(new CustomEvent('ob:cart:added', { detail: res }));
          return res;
        });
      });
    }
  };

  /* Native cart quantity changes, removals and additions share this event. */
  var cartRefreshTimer;
  document.addEventListener('cart:update', function (event) {
    var detail = event.detail || {};
    if (detail.data && detail.data.didError) return;
    clearTimeout(cartRefreshTimer);
    var cart = detail.resource;
    if (cart && typeof cart.item_count === 'number') Cart.paint(cart.item_count);
    else cartRefreshTimer = setTimeout(function () { Cart.refresh(); }, 40);
  });
  window.addEventListener('pageshow', function (event) { if (event.persisted) Cart.refresh(); });

  /* ---------------- wishlist (local to this browser) ---------------- */
  function read(k, d) { try { return JSON.parse(localStorage.getItem(k)) || d; } catch (e) { return d; } }
  function write(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { } }
  var Wish = {
    all: function () { var value = read('ob_wish', {}); return value && typeof value === 'object' && !Array.isArray(value) ? value : {}; },
    has: function (h) { return !!this.all()[h]; },
    count: function () { return Object.keys(this.all()).length; },
    toggle: function (h) {
      var w = this.all();
      if (w[h]) delete w[h]; else w[h] = 1;
      write('ob_wish', w);
      paintWishCount();
      return !!w[h];
    }
  };
  function paintWishCount() {
    var n = Wish.count();
    document.querySelectorAll('[data-wish-count]').forEach(function (e) {
      e.textContent = n; e.style.display = n ? '' : 'none';
    });
    document.querySelectorAll('.wish[data-h], #obWishBtn[data-h]').forEach(function (b) {
      var saved = Wish.has(b.getAttribute('data-h'));
      b.classList.toggle('on', saved);
      b.setAttribute('aria-pressed', String(saved));
    });
  }
  function wishClick(e, h) {
    e.preventDefault(); e.stopPropagation();
    var on = Wish.toggle(h);
    var b = e.currentTarget; b.classList.toggle('on', on);
    if (b.closest('#obWishList')) openWishlist();
    toast(on ? 'Saved to wishlist' : 'Removed from wishlist');
    return false;
  }

  /* ---------------- bottom sheet ---------------- */
  var bg, sheet, sheetTrigger, sheetOverflow;
  var sheetBackground = [];
  function ensureSheet() {
    if (sheet) return;
    bg = el('<div class="sheet-bg" id="obSheetBg"></div>');
    sheet = el('<div class="sheet" id="obSheet" role="dialog" aria-modal="true" aria-labelledby="obSheetTitle" aria-hidden="true" tabindex="-1" inert>' +
      '<div class="grab"></div>' +
      '<div class="sheet-hd"><h3 id="obSheetTitle"></h3><button id="obSheetX" aria-label="Close">' + I.close + '</button></div>' +
      '<div class="sheet-bd" id="obSheetBody"></div>' +
      '<div class="sheet-ft" id="obSheetFoot"></div></div>');
    overlayRoot().appendChild(bg); overlayRoot().appendChild(sheet);
    bg.onclick = closeSheet;
    sheet.querySelector('#obSheetX').onclick = closeSheet;
  }
  function openSheet(title, body, foot) {
    ensureSheet();
    sheet.querySelector('#obSheetTitle').textContent = title;
    sheet.querySelector('#obSheetBody').innerHTML = body;
    sheet.querySelector('#obSheetFoot').innerHTML = foot || '';
    if (!sheet.classList.contains('on')) {
      sheetTrigger = document.activeElement;
      sheetOverflow = document.body.style.overflow;
      sheetBackground = [];
      Array.prototype.forEach.call(document.body.children, function (node) {
        if (node === overlayRoot()) return;
        sheetBackground.push({ node: node, inert: node.inert });
        node.inert = true;
      });
    }
    sheet.inert = false;
    sheet.removeAttribute('aria-hidden');
    bg.classList.add('on'); sheet.classList.add('on');
    document.body.style.overflow = 'hidden';
    sheet.querySelector('#obSheetX').focus();
  }
  function closeSheet() {
    if (!sheet || !sheet.classList.contains('on')) return;
    bg.classList.remove('on'); sheet.classList.remove('on');
    sheetBackground.forEach(function (item) { item.node.inert = item.inert; });
    sheetBackground = [];
    document.body.style.overflow = sheetOverflow || '';
    if (sheetTrigger && sheetTrigger.isConnected && !sheet.contains(sheetTrigger)) sheetTrigger.focus();
    sheet.inert = true;
    sheet.setAttribute('aria-hidden', 'true');
  }
  document.addEventListener('keydown', function (event) {
    if (!sheet || !sheet.classList.contains('on')) return;
    if (event.key === 'Escape') { event.preventDefault(); closeSheet(); return; }
    if (event.key !== 'Tab') return;
    var controls = Array.prototype.filter.call(sheet.querySelectorAll('a[href], button, input, select, textarea, [tabindex]'), function (node) {
      return !node.disabled && node.tabIndex >= 0 && !node.closest('[inert], [hidden]') && node.getClientRects().length;
    });
    var first = controls[0] || sheet;
    var last = controls[controls.length - 1] || sheet;
    if (event.shiftKey && (document.activeElement === first || !sheet.contains(document.activeElement))) {
      event.preventDefault(); last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !sheet.contains(document.activeElement))) {
      event.preventDefault(); first.focus();
    }
  });

  /* ---------------- wishlist sheet ---------------- */
  function openWishlist(e) {
    if (e) e.preventDefault();
    var handles = Object.keys(Wish.all());
    if (!handles.length) {
      openSheet('My wishlist',
        '<div class="empty" style="padding:26px 0"><div class="ic">' + I.heart + '</div>' +
        '<h3>Your wishlist is empty</h3><p>Tap the heart on any product to save it here.</p></div>');
      return;
    }
    openSheet('My wishlist (' + handles.length + ')', '<div id="obWishList">Loading…</div>');
    var box = document.getElementById('obWishList');
    Promise.all(handles.slice(0, 60).map(function (h) {
      return fetch(CFG.routes.root.replace(/\/$/, '') + '/products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (list) {
      if (document.getElementById('obWishList') !== box) return;
      var rows = list.map(function (p, index) {
        var handle = handles[index];
        var title = p ? p.title : ((CFG.strings || {}).savedUnavailable || 'Saved product unavailable');
        var img = '';
        if (p && p.featured_image) {
          var imageUrl = new URL(p.featured_image, location.origin);
          imageUrl.searchParams.set('width', '120');
          img = '<img src="' + esc(imageUrl.href) + '" alt="" width="56" height="56">';
        }
        var content = img + '<span style="flex:1;min-width:0"><b>' + esc(title) + '</b>' +
          (p ? '<span class="p tnum" style="font-size:13px;font-weight:700">' + money(p.price) + '</span>' : '') + '</span>';
        var link = p ? '<a class="ob-wish-link" href="' + CFG.routes.root.replace(/\/$/, '') + '/products/' + esc(handle) + '">' + content + '</a>' : '<span class="ob-wish-link">' + content + '</span>';
        return '<div class="ob-wish-row">' + link +
          '<button type="button" class="wish on" data-h="' + esc(handle) + '" aria-pressed="true" aria-label="' + esc((CFG.strings || {}).removeSaved || 'Remove from wishlist') + '" ' +
          'onclick="return OB.wishClick(event,\'' + esc(handle) + '\')">' + I.heartSm + '</button></div>';
      }).join('');
      box.innerHTML = rows;
    });
  }

  /* ---------------- rails ---------------- */
  function railScroll(id, dir) {
    var r = document.getElementById(id);
    if (r) r.scrollBy({ left: dir * Math.round(r.clientWidth * 0.82), behavior: 'smooth' });
  }
  function wireRails(root) {
    (root || document).querySelectorAll('.rail-wrap').forEach(function (w) {
      if (w.__wired) return; w.__wired = 1;
      var r = w.querySelector('.scroll-x'), l = w.querySelector('.rail-nav.l'), rr = w.querySelector('.rail-nav.r');
      if (!r) return;
      function upd() {
        if (l) l.hidden = r.scrollLeft < 8;
        if (rr) rr.hidden = r.scrollLeft + r.clientWidth >= r.scrollWidth - 8;
      }
      r.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      setTimeout(upd, 60);
    });
  }

  /* ---------------- scroll reveal ---------------- */
  var io;
  function reveal(root) {
    var nodes = (root || document).querySelectorAll('.rev:not(.in)');
    if (!('IntersectionObserver' in window)) { nodes.forEach(function (n) { n.classList.add('in'); }); return; }
    if (!io) {
      io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px 160px 0px', threshold: 0.04 });
    }
    nodes.forEach(function (n) {
      if (n.getBoundingClientRect().top > window.innerHeight) n.classList.add('ob-reveal-pending');
      io.observe(n);
    });
  }

  /* ---------------- header autohide + back-to-top ---------------- */
  function scrollChrome() {
    var hdr = document.getElementById('hdr');
    var alwaysVisible = hdr && hdr.getAttribute('data-ob-sticky') === 'always';
    if (alwaysVisible) hdr.classList.remove('hide');
    var top = el('<button class="backtop" aria-label="Back to top">' + I.up + '</button>');
    overlayRoot().appendChild(top);
    top.onclick = function () { window.scrollTo({ top: 0, behavior: 'smooth' }); };
    var last = 0, ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        if (hdr) hdr.classList.toggle('hide', !alwaysVisible && window.innerWidth < 900 && y > last && y > 220);
        top.classList.toggle('on', y > 700);
        last = y; ticking = false;
      });
    }, { passive: true });
  }

  /* ---------------- carousel (hero + PDP gallery) ---------------- */
  function carousel(trackId, dotsId, opts) {
    opts = opts || {};
    var track = document.getElementById(trackId), dots = document.getElementById(dotsId);
    if (!track || !track.children.length) return;
    if (track.__obCarouselCleanup) track.__obCarouselCleanup();
    var n = track.children.length, i = 0;
    var frame = 0, timer, paused = false, hovered = false;
    var toggle = opts.toggle && document.getElementById(opts.toggle);
    var region = track.parentElement;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function position(k) {
      var first = track.children[0].getBoundingClientRect().left;
      var left = track.children[k].getBoundingClientRect().left - first;
      return Math.max(0, Math.min(left, track.scrollWidth - track.clientWidth));
    }
    function sync() {
      frame = 0;
      var distance = Infinity;
      for (var k = 0; k < n; k++) {
        var delta = Math.abs(track.scrollLeft - position(k));
        if (delta < distance) { distance = delta; i = k; }
      }
      if (dots) [].forEach.call(dots.children, function (b, j) {
        b.classList.toggle('on', j === i);
        b.setAttribute('aria-current', j === i ? 'true' : 'false');
      });
      if (opts.counter) {
        var c = document.getElementById(opts.counter);
        if (c) c.textContent = (i + 1) + '/' + n;
      }
    }
    function go(k, instant) {
      track.scrollTo({ left: position(k), behavior: instant || reducedMotion ? 'instant' : 'smooth' });
    }
    function onScroll() {
      if (!frame) frame = requestAnimationFrame(sync);
    }
    function onResize() { go(i, true); sync(); }
    function paintToggle() {
      if (toggle) toggle.textContent = toggle.getAttribute(paused ? 'data-play-label' : 'data-pause-label');
    }
    function pause() { paused = true; paintToggle(); }
    function onFocus(event) { if (event.target !== toggle) pause(); }
    function onEnter() { hovered = true; }
    function onLeave() { hovered = false; }
    function startAuto() {
      clearInterval(timer);
      if (!opts.auto || n < 2 || reducedMotion) return;
      timer = setInterval(function () {
        if (!track.isConnected) { cleanup(); return; }
        if (!paused && !hovered && !document.hidden) { sync(); go((i + 1) % n); }
      }, opts.auto);
    }
    if (dots) {
      [].forEach.call(dots.children, function (b, k) {
        b.onclick = function () { pause(); go(k); };
      });
    }
    if (toggle) {
      toggle.hidden = reducedMotion || !opts.auto || n < 2;
      toggle.onclick = function () { paused = !paused; paintToggle(); startAuto(); };
    }
    region.addEventListener('focusin', onFocus);
    region.addEventListener('mouseenter', onEnter);
    region.addEventListener('mouseleave', onLeave);
    function cleanup() {
      clearInterval(timer);
      region.removeEventListener('focusin', onFocus);
      region.removeEventListener('mouseenter', onEnter);
      region.removeEventListener('mouseleave', onLeave);
      if (toggle) toggle.onclick = null;
      if (dots) [].forEach.call(dots.children, function (b) { b.onclick = null; });
      cancelAnimationFrame(frame);
      track.removeEventListener('scroll', onScroll);
      track.removeEventListener('pointerdown', pause);
      window.removeEventListener('resize', onResize);
      delete track.__obCarouselCleanup;
    }
    track.__obCarouselCleanup = cleanup;
    track.addEventListener('scroll', onScroll, { passive: true });
    track.addEventListener('pointerdown', pause, { passive: true });
    window.addEventListener('resize', onResize);
    sync();
    startAuto();
  }

  /* ---------------- pincode estimate ---------------- */
  function pinCheck() {
    var input = document.getElementById('pin'), msg = document.getElementById('pinMsg'), lbl = document.getElementById('pinLbl');
    if (!input) return;
    var v = input.value.trim();
    if (!/^\d{6}$/.test(v)) { msg.style.color = 'var(--red)'; msg.textContent = 'Please enter a valid 6-digit pincode.'; return; }
    var days = 3 + (parseInt(v.slice(-1), 10) % 4);
    var d = new Date(Date.now() + days * 864e5);
    msg.style.color = 'var(--green)';
    msg.textContent = 'Estimated delivery by ' + d.toLocaleDateString('en-IN', { weekday: 'long', day: 'numeric', month: 'short' });
    if (lbl) lbl.textContent = 'Delivering to ' + v;
  }

  /* ---------------- tabs / accordions on the PDP ---------------- */
  function tab(btn, id) {
    btn.parentElement.querySelectorAll('.tabbtn').forEach(function (x) { x.setAttribute('aria-selected', 'false'); });
    btn.setAttribute('aria-selected', 'true');
    btn.parentElement.parentElement.querySelectorAll('.panel').forEach(function (x) { x.classList.toggle('on', x.id === id); });
  }

  /* ---------------- init ---------------- */
  function boot() {
    /* `.ob-root` on <body> is NOT set here any more. It means "this whole
       page is Oblivion's", which is only true on the five Oblivion
       templates — layout/theme.liquid sets it server-side for those, and
       oblivion-header.liquid repeats it inline as a fallback. On GemPages
       product pages and the theme's own pages the header, tab bar and
       footer scope themselves through their `.ob-chrome` wrapper instead,
       so adding it here would hand Oblivion the whole page by mistake. */
    Cart.paint(CFG.cartCount || 0);
    paintWishCount();
    scrollChrome();
    reveal();
    wireRails();
    document.querySelectorAll('[data-ob-wishlist]').forEach(function (a) { a.addEventListener('click', openWishlist); });
    if (window.innerWidth >= 900) {
      var si = document.getElementById('obSearch');
      if (si) si.placeholder = 'Search for products, brands and more';
    }
  }

  window.OB = {
    esc: esc, el: el, qs: qs, money: money, I: I,
    Cart: Cart, Wish: Wish, wishClick: wishClick, paintWishCount: paintWishCount, toast: toast,
    openSheet: openSheet, closeSheet: closeSheet, openWishlist: openWishlist,
    railScroll: railScroll, wireRails: wireRails, reveal: reveal,
    carousel: carousel, pinCheck: pinCheck, tab: tab, boot: boot
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
